module.exports = __webpack_public_path__ + "static/img/2.5f1d967.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/zh/2.png
// module id = Xn/S
// module chunks = 0